// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._19bvv47k{padding-left:var(--ds-space-250,20px)}
._bozgv47k{padding-inline-start:var(--ds-space-250,20px)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/smart-card/dist/esm/view/common/ai-summary/ulist.compiled.css"],"names":[],"mappings":"AAAA,WAAW,qCAAqC;AAChD,WAAW,6CAA6C","sourcesContent":["._19bvv47k{padding-left:var(--ds-space-250,20px)}\n._bozgv47k{padding-inline-start:var(--ds-space-250,20px)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
